import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import DocumentationPage from './pages/DocumentationPage';
import SearchPage from './pages/SearchPage';
import 'react-medium-image-zoom/dist/styles.css';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/*" element={<DocumentationPage />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
